import React from "react";
import { FiArrowRight } from "react-icons/fi";
import {
  HomePresentationContainer,
  HomePresentationContent,
  HomePresentationImage,
  HomePresentationImageFrame,
  HomePresentationInner,
} from "./HomePresentationElements";
import { Reveal } from "../../general/Reveal";
import { BodyText, Eyebrow, Heading } from "../../general/Typography";
import { ArrowLink } from "../../general/Button";

const HomePresentation = ({
  title,
  label,
  image,
  description,
  link,
  linkText,
  isImageOnLeft = false,
}) => {
  return (
    <HomePresentationContainer $tinted={isImageOnLeft}>
      <HomePresentationInner $imageOnLeft={isImageOnLeft}>
        <Reveal from={isImageOnLeft ? "left" : "right"} duration={1}>
          <HomePresentationImageFrame $imageOnLeft={isImageOnLeft}>
            <HomePresentationImage alt={title} src={image} loading="lazy" />
          </HomePresentationImageFrame>
        </Reveal>
        <HomePresentationContent>
          <Reveal delay={0.05}>
            <Eyebrow>{label}</Eyebrow>
          </Reveal>
          <Reveal delay={0.15}>
            <Heading>{title}</Heading>
          </Reveal>
          <Reveal delay={0.25}>
            <BodyText>{description}</BodyText>
          </Reveal>
          {link && (
            <Reveal delay={0.35}>
              <ArrowLink to={link}>
                {linkText}
                <FiArrowRight />
              </ArrowLink>
            </Reveal>
          )}
        </HomePresentationContent>
      </HomePresentationInner>
    </HomePresentationContainer>
  );
};

export default HomePresentation;
